/** First-run cards: the welcome card, the permission cards' headings and
 *  spoken prompts, the voice list and how Denker hears you. */
export default {
  welcomeEyebrow: "Welcome",
  setupEyebrow: "Denker · Setup",
  defaultTitle: "Make yourself at home.",
  welcomeTitle: "Hi, I’m Denker.",
  welcomeDescription: "How should we talk?",
  welcomeNarration: "Hi, I’m Denker. How should we talk?",
  permissionsTitle: "A few permissions.",
  permissionsDescription: "Choose what Denker can use on this computer.",
  permissionsNarration:
    "A few permissions. Choose what Denker can use on this computer.",
  microphoneTitle: "Microphone access.",
  accessibilityTitle: "Accessibility access.",
  screenRecordingTitle: "Screen Recording access.",
  windowsInputTitle: "Input control.",
  microphonePrompt: "I need Microphone so I can hear your voice.",
  accessibilityPrompt: "Allow Accessibility for shortcuts.",
  screenRecordingPrompt: "I need Screen Recording to co-work on your screen.",
  windowsMicrophonePrompt: "I can't hear you yet. Here's what Windows needs.",
  windowsInputPrompt:
    "Windows has no switch for this, so I have to ask you myself.",
  runtimeTitle: "Connect your AI.",
  runtimeDescription:
    "Use a subscription you already have, or start with Denker’s included AI.",
  browserTitle: "Add the Denker extension.",
  browserTwo: "Denker sets up two browsers for you.",
  browserOne: "Denker sets up one browser for you.",
  browserOneAtATime: "One browser at a time.",
  browserYoursName: "Your browser",
  browserYours: "Where you’re already signed in.",
  browserChipDefault: "{browser} · default",
  browserDenkerName: "Denker browser",
  browserDenker: "Its own window, your tabs stay yours. Sign in there once.",
  browserAsk:
    "Just tell Denker which one to use for a task: its own window, or yours.",
  browserMore: "Add more browsers in Settings.",
  browserNone:
    "Denker works on web pages in Google Chrome, Microsoft Edge or Brave. Install one, then connect it in Settings > Plugins > Connections > Browsers.",
  browserTickStore: "Store page opens in {browser}",
  browserTickStoreDenker: "Store page opens in the Denker browser",
  browserTickOpenLink: "Open the link on your clipboard in {browser}",
  browserTickOpenLinkDenker:
    "Open the link on your clipboard in the Denker browser",
  browserTickAdd: "Click “Add to Chrome”",
  browserTickAddEdge: "Allow extensions from other stores, then click “Get”",
  browserTickTurnOn: "Turn the extension on in {browser}",
  browserTickTurnOnDenker: "Turn the extension on in the Denker browser",
  browserTickAgree: "Click “Agree” on the welcome page",
  browserTickRestart: "Close and reopen {browser}",
  browserTickRestartDenker: "Close and reopen the Denker browser",
  browserTickSafariOpens: "Safari opens",
  browserTickSafariAllow: "Allow Denker in the macOS prompt",
  browserNext: "Next",
  browserBothConnected: "Both connected.",
  browserConnected: "{browser} is connected.",
  browserOtherLater: "Try the other one again, or add it later in Settings.",
  browserNotYet: "Not connected yet. Try again, or add it later in Settings.",
  browserSetUpBoth: "Set up both",
  browserSetUp: "Set up",
  browserWaiting: "Waiting…",
  browserStop: "Stop",
  browserSkipForNow: "Skip for now",
  allSet: "Great, you are all set.",
  closeSettingsThenReopen: "Close System Settings, then reopen Denker.",
  pickReplyVoice: "Pick one voice for agent replies.",
  previewVoice: "Preview {name}",
  voiceSelected: "{name} voice selected",
  selectVoice: "Select {name} voice",
  setUpLater: "Set up later",
  iSpeak: "I speak",
  addLanguage: "Add a language",
  noLanguageMatch: "No match",
  removeLanguage: "Remove {language}",
  noVoice: "no voice",
  noVoiceYet: "no voice yet",
  answersAloudIn:
    "Denker understands {languages}, but answers aloud in {language}.",
  listensWith: "Denker listens with",
  suggested: "Suggested",
  modelSize: "{size} MB",
  builtIn: "Built in",
  modelInstalled: "Downloaded",
  appleSpeech: "Apple speech",
  windowsSpeech: "Windows speech",
  appleSpeechLine: "No download. One language at a time.",
  windowsSpeechLine: "No download. One language at a time, sent to Microsoft.",
  modelDownloadProgress: "{model} · {percent}%",
  modelDownloadProgressMeanwhile:
    "{model} · {percent}%. {engine} listens meanwhile.",
  modelDownloadFailed: "Couldn’t download {model}.",
  dictationWaitTitle: "Getting dictation ready.",
  dictationWaitText: "Denker can listen once {model} is in.",
  dictationWaitSkip: "Skip for now",
  howDenkerSpeaks: "Denker speaks as",
  previewAndSelectVoice: "Preview and select {name} voice",
  next: "Next",
  toneClearWarm: "Clear, warm",
  toneFriendlyLight: "Friendly, light",
  toneLightLively: "Light, lively",
  toneBrightClear: "Bright, clear",
} as const;
